module.exports = "/static/assets/133e4aa38e1bf1623a771873b842dabc.png";